import { render, staticRenderFns } from "./OrganizationsListContainer.vue?vue&type=template&id=7aa99c40&scoped=true"
import script from "./OrganizationsListContainer.vue?vue&type=script&lang=js"
export * from "./OrganizationsListContainer.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsListContainer.vue?vue&type=style&index=0&id=7aa99c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa99c40",
  null
  
)

export default component.exports